import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-320971c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "noticeContainer" }

import { ElNotification } from "element-plus";
import store from "@/store";
import { useRouter } from "vue-router";
import { computed, watch } from "vue";
import { getDictList } from "@/api/request";
import Tea from "@dp/byted-tea-sdk-oversea";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'NewNotice',
  setup(__props) {

const { t } = useI18n();
const router = useRouter();
const info = computed(() => {
  return store.state.notice.newNoticeInfo;
});
watch(
  () => {
    return store.state.notice.newNoticeDialog;
  },
  async (newval) => {
    if (newval) {
      const notificationRef = ElNotification({
        title: t("您有新的消息！"),
        dangerouslyUseHTMLString: true,
        message: `<div>${
          info.value.noticeContent
        }<br/><div class='notice-link'>${t("立即查看")}</div></div>`,
        position: "top-right",
        onClose() {
          store.commit("SET_NEW_NOTICE_DIALOG", false);
        },
        onClick() {
          // router.push({
          //   path: "/mobile/courseContent",
          //   query: {
          //     id: info.value.jumpUrl,
          //   },
          // });
          if (
            info.value.noticeType === 1 ||
            info.value.noticeType === 2 ||
            info.value.noticeType === 3 ||
            info.value.noticeType === 4 ||
            info.value.noticeType === 5 ||
            info.value.noticeType === 12
          ) {
            Tea.event("site_mail_click", {
              client: "mobile",
              source: "course",
              index: info.value.noticeType,
            });
            // 课程相关站内信跳转操作
            router.push({
              path: "/mobile/courseContent",
              query: {
                id: info.value.jumpUrl,
              },
            });
            notificationRef.close();
          }
          if (
            info.value.noticeType === 6 ||
            info.value.noticeType === 7 ||
            info.value.noticeType === 8 ||
            info.value.noticeType === 11
          ) {
            Tea.event("site_mail_click", {
              client: "mobile",
              source: "certificate",
              index: info.value.noticeType,
            });
            // 人才认证相关站内信跳转操作
            router.push({
              path: "/mobile/authentication",
            });
            notificationRef.close();
          }
          if (info.value.noticeType === 9 || info.value.noticeType === 10) {
            // 代理商信息完善相关站内信跳转操作
            getDictList({ type: "class_flag_id" }).then((res) => {
              let successId = [] as string[];
              res.data.forEach((item) => {
                successId.push(item.value);
              });
              Tea.event("site_mail_click", {
                client: "mobile",
                source: "agent",
                index: info.value.noticeType,
              });
              router.push({
                path: "/mobile/course",
                query: {
                  classId: successId[0],
                },
              });
              notificationRef.close();
            });
          }
        },
      });
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})